export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">关于菲菲</h2>
        <p className="text-sm text-foreground-500 mb-8 leading-relaxed">
          菲菲影院创立于2024年，是一个专注于为广大影迷提供<strong>免费高清电影在线观看</strong>服务的平台。
          我们致力于打造最全面的电影大全，收录最新高清电影、高分动作片、喜剧片等丰富类型，
          坚持以用户观影体验为核心，不断优化播放技术和片库覆盖。
        </p>
        <p className="text-sm text-foreground-500 leading-relaxed mb-8">
          从经典老片到院线新作，菲菲影院每日更新海量电影资源，确保每一位影迷都能在这里找到心仪的影片。
          流畅不缓冲的播放体验、简洁直观的界面设计，让看电影回归纯粹的享受。
          未来，我们将持续扩展内容库，为更多电影爱好者提供高质量的免费在线观影服务。
        </p>
        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-foreground-600">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-user-smile-line text-accent-500"></i>
            服务超过百万影迷
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-movie-line text-accent-500"></i>
            20000+电影资源
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-shield-check-line text-accent-500"></i>
            安全纯净观影
          </span>
        </div>
      </div>
    </section>
  );
}